<template>
  <v-container fluid>
    <v-card class="mx-auto my-3">
      <v-toolbar flat color="white" elevation="1">
        <v-spacer></v-spacer>

        <v-toolbar-title style="font-weight: bolder"
          >{{ $filters.capitalize($t(`prod_availability.label`, 1) ) }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-card>
      <v-table
        fixed-header
          height="95vh"
          class="tight-table"
        >
        <template v-slot:default>
          <thead>
            <tr style="width: 100%">
              <th
                :class="'text-left ' + stickyStateClass + 'sticky-column'"
                style="width: 130px; height: 36px !important"
              >
                {{ $filters.capitalize($t("prod_availability.date", 10) ) }}
              </th>
              <th
                :class="'text-left th-date ' + stickyStateClass"
                v-for="sheet in dateKeys"
                :key="sheet.id"
              >
                {{ $filters.formatDat(sheet.date) }}
              </th>
              <th
                :class="'text-left ' + stickyStateClass"
                style="width: auto; height: auto"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in PAitems" :key="item.id">
              <td class="sticky-column">{{ item.display_name }}</td>
              <td colspan="10">
                <v-tooltip
                  v-for="sheet in item.values"
                  :key="sheet.id"
                  :text="$filters.formatDate(sheet.date)"
                  location="top"
                >
                  <template v-slot:activator="{ props }">
                    <v-sheet
                      v-bind="props"
                      :color="get_color_int(sheet.value)"
                      :class="'sheet_step ' + get_step_ink(sheet.value)"
                      elevation="3"
                      height="32"
                      width="32"
                      rounded
                    >{{ $filters.formatAvailability(sheet.value) }}</v-sheet>
                  </template>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-table>
    </v-card>
  </v-container>
</template>

<script>
import { isNone } from "@/functions.js";
import utils from "@/mixins/utils";

export default {
  mixins: [utils],

  created() {
    this.$store.dispatch(`${this.moduleName}/getMonthItems`).then((items) => {
      this.PAitems = items;
    });
  },

  computed: {
    dateKeys: function () {
      if (!isNone(this.PAitems) && this.PAitems.length > 0) {
        return this.PAitems[0].values.filter((p, i) => i % 5 === 0);
      }
      return [];
    },
  },

  methods: {
    rgbToHex(r, g, b) {
      // int '255' color to hex
      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },

    pickHex(color1, color2, weight) {
      // interpolate color between two colors
      const w1 = weight;
      const w2 = 1 - w1;
      const rgb = [
        Math.round(color1[0] * w1 + color2[0] * w2),
        Math.round(color1[1] * w1 + color2[1] * w2),
        Math.round(color1[2] * w1 + color2[2] * w2),
      ];

      return this.rgbToHex(rgb[0], rgb[1], rgb[2]);
    },

    get_color_int(value) {
      // interpolate color from a gradient
      const value_ = parseFloat(value);
      if(isNone(value)) return '#ffffff'
      var step = 0;
      for (var i = 0; i < this.gradient.length; i++) {
        const val = this.gradient[i][0];
        if (value_ <= val) {
          step = i;
          break;
        }
      }
      var begin = this.gradient[step - 1];
      if (step === 0) {
        begin = this.gradient[step];
      }
      const end = this.gradient[step];
      var ratio = 1 - (end[0] - value_) / (end[0] - begin[0]);
      if (isNone(ratio) && !isNaN(value_)) {
        ratio = 0;
      }
      const hex = this.pickHex(end[1], begin[1], ratio);
      return hex;
    },

    get_step_ink(value) {
      // get text color for text inside sheep
      const value_ = parseFloat(value);
      if (value_ < 50) {
        return "text-inverted";
      }
    },

  },

  data() {
    return {
      moduleName: "prod_availabilities",
      PAitems: undefined,
      stickyStateClass: "",
      gradient: [
        [0, [0, 0, 0]],
        [
          60,
          [255, 0, 0], // #FF0000
        ],
        [
          80,
          [255, 242, 0], // #FFF200
        ],
        [
          97,
          [30, 150, 0], // #1E9600
        ],
        [
          100,
          [30, 150, 0], // #1E9600
        ],
      ],
    };
  },
};
</script>

<style scoped>

.sheet_step {
  display: inline-block;
  margin: 0 1px;
  text-align: center;
  padding-top: 6px;
  margin-bottom: 5px;
}
.text-inverted {
  color: white;
}
.th-date {
  width: 170px;
  height: 36px !important;
}


table {
  table-layout: auto;
  border-spacing: 2;
  width: 100%;
}

.sticky-column {
  position: -webkit-sticky; /* For Safari */
  position: sticky;
  width: 10em;
  left: 0;
  background: white; /* Ensure background matches table */
  z-index: 1; /* Ensure it is above other cells */
}

.tight-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
}

.tight-table th,
.tight-table td {
  margin: 0;
  padding: 2px 4px; /* Adjust padding as needed */
}

.grey-row {
  background-color: #f2f2f2;
}

.white-row {
  background-color: #ffffff;
}

</style>
